<template>
    <article class="LanguageForm flex gap-4">
        <CFormGroup class="mb-0!">
            <CFormSearchSelect
                :disabled="disabled"
                :has-suffix="hasSuffix"
                :model-value="modelValue.code"
                :options="languageCodeOptions"
                placeholder="Vybrať jazyk"
                :suffix-icon="suffixIcon"
                :value-key="'value'"
                :label-key="'label'"
                @update:model-value="
                    (value) => {
                        console.log('Language code selected:', value)
                        update({ code: value as LanguageCode })
                    }
                "
            />
        </CFormGroup>

        <CFormGroup class="mb-0!">
            <CFormSelect
                :disabled="disabled"
                :has-suffix="hasSuffix"
                :options="languageLevelOptions"
                :label-key="'label'"
                :value-key="'value'"
                placeholder="Vybrať úroveň"
                :suffix-icon="suffixIcon"
                :model-value="modelValue.level"
                @update:model-value="update({ level: $event as LanguageLevel })"
            />
        </CFormGroup>
    </article>
</template>

<script setup lang="ts">
import type { LanguageCode } from 'iso-639-1'
import { computed } from 'vue'

import { type Language, LanguageLevel } from '#shared/types/Language'
import { getLanguages } from '#shared/utils/language'
import CFormGroup from '@/components/ui/CFormGroup.vue'
import CFormSearchSelect from '@/components/ui/CFormSearchSelect.vue'
import CFormSelect from '@/components/ui/CFormSelect.vue'

interface Props {
    lang?: 'sk' | 'en'
    modelValue?: Language
    disabled?: boolean
    hasSuffix?: boolean
    suffixIcon?: string
}

const props = withDefaults(defineProps<Props>(), {
    lang: 'sk',
    modelValue: () => ({}) as Language,
    disabled: false,
    suffixIcon: undefined
})

const emit = defineEmits<{
    'update:model-value': [value: Language]
}>()

const languageLevels = Object.values(LanguageLevel)

const languageCodeOptions = computed(() => {
    const languages = getLanguages(props.lang)
    const options = Object.entries(languages).map(([code, name]) => ({
        value: code,
        label: name
    }))

    // Debug: log the first few options to console
    if (options.length > 0) {
        console.log('Sample language options:', options.slice(0, 3))
    }

    return options
})

const languageLevelOptions = computed(() => {
    return languageLevels.map((level) => ({
        value: level,
        label: level.toString()
    }))
})

function update(change: Partial<Language>) {
    const updatedValue = { ...props.modelValue, ...change }
    console.log('LanguageForm update called with:', change)
    console.log('Current modelValue:', props.modelValue)
    console.log('Updated value:', updatedValue)
    emit('update:model-value', updatedValue)
}
</script>
